import { clsx } from 'clsx';
import dayjs from 'dayjs';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const localDate = date => (date ? dayjs(date).format('L') : '');

export const localDateToMinutes = date =>
    date ? dayjs(date).format('L LT') : '';

export const localDateToSeconds = date =>
    date ? dayjs(date).format('L LTS') : '';

export const apiDate = date => (date ? dayjs(date).format('YYYY-MM-DD') : '');

const numberFormatter = new Intl.NumberFormat('nl-NL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

/**
 * Parse a Dutch-formatted number ("1.234,56") into a float. Dots are treated as
 * thousand separators and the comma as the decimal mark. Returns null when the
 * value cannot be parsed.
 */
export const parseNumber = value => {
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null;
    }

    if (typeof value !== 'string') {
        return null;
    }

    const parsed = parseFloat(
        value
            .replace(/[^\d,.-]/g, '')
            .replace(/\./g, '')
            .replace(',', '.')
    );

    return Number.isNaN(parsed) ? null : parsed;
};

/** Format a number (or Dutch-formatted string) as "1.234,56". */
export const formatNumber = value => {
    const parsed = parseNumber(value);

    return parsed === null ? '' : numberFormatter.format(parsed);
};

export const formatMoney = (amount, currency = 'EUR') => {
    if (amount === null || amount === undefined) {
        return '';
    }

    return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);
};

export const IMAGE_FILE_TYPE = 'image/*';
export const PDF_FILE_TYPE = 'application/pdf';
